import { forwardRef, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  kawaiiBaseStyles,
  kawaiiFocusStyles,
  kawaiiVariantStyles,
  kawaiiHoverGlowStyles,
} from './kawaiiStyles';

interface KawaiiButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  icon?: React.ReactNode;
  fullWidth?: boolean;
}

const KawaiiButtonComponent = forwardRef<HTMLButtonElement, KawaiiButtonProps>(
  ({ children, variant = 'primary', icon, fullWidth, className = '', ...props }, ref) => {
    const variantStyleSet = kawaiiVariantStyles[variant];

    return (
      <button
        ref={ref}
        className={twMerge(
          kawaiiBaseStyles,
          variantStyleSet.base,
          !props.disabled && variantStyleSet.hover,
          !props.disabled && variantStyleSet.active,
          kawaiiFocusStyles,
          kawaiiHoverGlowStyles,
          fullWidth ? 'w-full' : '',
          className,
        )}
        {...props}
      >
        {icon}
        {children}
        {/** <div className="absolute -inset-0.5 bg-linear-to-r from-pink-200 to-purple-200 dark:from-pink-500/50 dark:to-purple-500/50 rounded-full opacity-0 group-hover:opacity-75 group-active:opacity-75 group-focus-within:opacity-75 blur-xs z-10 transition-opacity duration-200 pointer-events-none" /> **/}
      </button>
    );
  },
);

KawaiiButtonComponent.displayName = 'KawaiiButton';

export const KawaiiButton = memo(KawaiiButtonComponent);
